import { SET_PIMS, GET_ALL_PIMS } from '../ActionTypes';

const initialState = {
    allPims: [],
    pims: [],
    pimsSettings: {
        directory: [`AVIMARK`],
        dbName: [
            `ADVANTAGE`,
            `CORNERSTONE`,
            `IMPROMED`,
            `VETBLUE`,
            `VETTERSOFT`,
            `VTECHPLATINUM`,
            `WOOFWARE`,
        ],
        dbPassword: [
            `ADVANTAGE`,
            `CORNERSTONE`,
            `DENTRIX`,
            `IMPROMED`,
            `VETBLUE`,
            `VETTERSOFT`,
            `VTECHPLATINUM`,
            `WOOFWARE`,
        ],
        dbUser: [
            `ADVANTAGE`,
            `CORNERSTONE`,
            `DENTRIX`,
            `IMPROMED`,
            `VETBLUE`,
            `VETTERSOFT`,
            `VTECHPLATINUM`,
            `WOOFWARE`,
        ],
        host: [`CORNERSTONE`, `DENTRIX`],
        odbcVersion: [`ADVANTAGE`, `CORNERSTONE`, `IMPROMED`, `WOOFWARE`],
        server: [
            `ADVANTAGE`,
            `CORNERSTONE`,
            `IMPROMED`,
            `VETBLUE`,
            `VETTERSOFT`,
            `VTECHPLATINUM`,
            `WOOFWARE`,
        ],
        storageType: [
            `ADVANTAGE`,
            `AVIMARK`,
            `CORNERSTONE`,
            `DVMAX`,
            `DVMMANAGER`,
            `EVETPRACTICE`,
            `IMPROMED`,
            `NEO`,
            `VETBLUE`,
            `VETTERSOFT`,
            `VTECHPLATINUM`,
            `WOOFWARE`,
        ],
        tableExtensions: [`AVIMARK`],
        tablesAll: [
            `ADVANTAGE`,
            `AVIMARK`,
            `CORNERSTONE`,
            `IMPROMED`,
            `VETBLUE`,
            `VETTERSOFT`,
            `VTECHPLATINUM`,
            `WOOFWARE`,
        ],
        tablesSpecific: [
            `ADVANTAGE`,
            `AVIMARK`,
            `CORNERSTONE`,
            `IMPROMED`,
            `VETBLUE`,
            `VETTERSOFT`,
            `VTECHPLATINUM`,
            `WOOFWARE`,
        ],
    },
};

const actionHandlers = (state = initialState, action) => {
    switch (action.type) {
        case SET_PIMS:
            return {
                ...state,
                pims: action.payload,
            };
        case GET_ALL_PIMS:
            return {
                ...state,
                allPims: action.payload,
            }
        default:
            return state;
    }
};

export default actionHandlers;
